import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { CommandNames } from 'utils/constants/swarm/swarm-command-names';
import { ELanguageSwitcherChangeEvents } from 'utils/generic/event-bus/external';
import { GLOBALS } from 'utils/generic/global-variables';
import { swarmCommand } from 'services/get-swarm-data';
import { useExternalEventbus } from 'newhooks/generic/useExternalEventbus';
import { getIsLoggedIn } from 'store/selectors/user-data';

const lang = document.documentElement.lang || 'en';

const PREFERRED_LANGUAGE_MAPPING: Record<string, string> = {
  'pt-br': 'por'
};

export const useHandlePreferredLanguage = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const currentSiteLangRef = useRef<string>('');

  useEffect(() => {
    if (isLoggedIn) {
      swarmCommand(
        CommandNames.SET_PREFERRED_LANGUAGE,
        {
          language:
            GLOBALS.languageConfigs.swarmLangPrefix ||
            PREFERRED_LANGUAGE_MAPPING[lang] ||
            PREFERRED_LANGUAGE_MAPPING[lang.slice(0, 2)] ||
            SpringConfigs.LANGUAGE_PREFIX ||
            'eng'
        },
        () => {}
      );
    }
  }, [isLoggedIn]);

  useExternalEventbus({
    [ELanguageSwitcherChangeEvents.SITE_LANGUAGE_CHANGED]: ({
      payload
    }: {
      payload: string;
    }) => {
      if (currentSiteLangRef.current === payload) {
        return;
      }

      currentSiteLangRef.current = payload;

      swarmCommand(
        CommandNames.CHANGE_SESSION_LANGUAGE,
        {
          language: currentSiteLangRef.current
        },
        () => {}
      );
    }
  });
};
